import React from "react"
import Container from "../../src/components/Container"
import Widget from "../../src/components/Widget"
import {registerNodeElement} from "../misc/node-registry"

const ContentTypeMap = Object.freeze({
    leafNode: props => <Widget widget={props.child} {...props} />,
    innerNode: props => <Container container={props.child} {...props} />,
})

const Content = (props) => {
    try {
        const content = ContentTypeMap[props.child.type](props)
        const nodeId = props.child?.id
        if (!nodeId) return content
        return (
            <div
                id={nodeId}
                ref={element => registerNodeElement(element, nodeId)}
                style={{display: "contents"}}
            >
                {content}
            </div>
        )
    } catch (error) {
        console.error(
            "Dieser Content hat einen Fehler erzeugt, schaue in der Konsole für mehr Infos",
            props.child,
            error,
        )
        return <>No Content</>
    }
}

export default Content
